// ***************************************************
// BOOKING FORM 
window._hotelBookingForm = {
    startDatePicker() {
        // https://www.daterangepicker.com/#example5

        const FORMAT = 'DD/MM/YYYY';
        const datepickerinput = $('input[name="check_in_check_out"]');
        const hidden_checkin = $('input[name="check_in"]');
        const hidden_checkout = $('input[name="check_out"]');

        let query_checkin = window.DryHelpers.getUrlParameter('check_in');
        let query_checkout = window.DryHelpers.getUrlParameter('check_out');
        let default_checkin = moment(new Date()).add(3, 'days');
        let default_checkout = moment(new Date()).add(4, 'days');

        let firstAvailableDay = query_checkin.length ? moment(query_checkin, FORMAT) : default_checkin;
        let dayAfter = query_checkout.length ? moment(query_checkout, FORMAT) : default_checkout;



        datepickerinput.daterangepicker({
            autoApply: true,
            autoUpdateInput: true,
            startDate: firstAvailableDay,
            endDate: dayAfter,
            minDate: default_checkin,
            locale: {
                format: FORMAT
            }
        });

        hidden_checkin.val( firstAvailableDay.format(FORMAT) );
        hidden_checkout.val( dayAfter.format(FORMAT) );

        datepickerinput.on('apply.daterangepicker', function (ev, picker) {
            let start = picker.startDate.format(FORMAT);
            let end = picker.endDate.format(FORMAT);
            
            // $(this).val(start + ' - ' + end);
            
            hidden_checkin.val(start );
            hidden_checkout.val(end );
        });

        datepickerinput.on('cancel.daterangepicker', function (ev, picker) {
            $(this).val('');
            hidden_checkin.val('');
            hidden_checkout.val('');
        });
    },
    handleOspitiDropdown() {
        const input = $('input[name="ospiti"]');
        const parent = input.closest(".input-dropdown-parent");
        const dropdown = parent.find('.input-dropdown')

        if (parent.closest('.hotel-search-form-boxed').length ) {
            return;
        }

        // open and close
        input.click(function () {
            dropdown.show();
        })

        $(document).click(function (e) {
            if (!input.is(e.target) && input.has(e.target).length === 0) {
                if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
                    dropdown.hide();
                }
            }
        });
    },

    startVueInstance(){
        new Vue({
            el: '#adulti_bambini',
            
            data: {
                adulti: null,
                bambini: null,
                eta_bambini : [],
            },

            created(){
                this.adulti = 2;
                this.bambini = 3;
                this.eta_bambini = [12,14,17,11,13,16]; 
                this.setData();
            },

            methods: {
                setData(){
                    const adulti = window.DryHelpers.getUrlParameter('adulti');
                    const bambini = window.DryHelpers.getUrlParameter('bambini');
                    let eta_bambini = [];
            
                    for(let i = 1; i <= bambini; i++) {
                        const key = 'eta_bambino_' + i;
                        eta_bambini.push( window.DryHelpers.getUrlParameter(key) )
                    }


                    if ( adulti ) this.adulti = parseInt(adulti);
                    if ( bambini ) this.bambini = parseInt(bambini);
                    if ( eta_bambini.length ) this.eta_bambini = eta_bambini;
                }
            },

            computed: {

                ospiti() {
                    return this.adulti + ' adulti - ' + this.bambini + ' bambini';
                }
            }
        })
    },
    init(){
        const t = this;
        $(document).ready(function(){
            t.startDatePicker();
            t.handleOspitiDropdown();
        })
        t.startVueInstance();
    }
}




// ***************************************************
// CRUISE PAGE (DATEPRICE TABLE) 
window.fixedCruiseTable = {
    distancesArray: [],
    cloneTable(){
        const table = $("#dateprice-table");
        const clone = table.clone();

        const th1 = table.find("th:first-child");
        const th2 = table.find("th:nth-child(2)");

        clone.attr('id', 'dateprice-table-cloned');

        clone.find("th:nth-child(n+3)").remove();
        clone.find("tr td:nth-child(n+3)").remove();

        clone.find("th:first-child").css({
            width: th1.outerWidth(),
            height: th1.outerHeight(),
        });
        clone.find("th:nth-child(2)").css({
            width: th2.outerWidth(),
            height: th2.outerHeight(),
        });

        clone.find("tbody tr").each(function(index, val){
            $(this).css('height', table.find("tbody tr").eq(index).outerHeight() );
        });

        table.after( clone );
    },
    createButtons(){
        const table = $("#dateprice-table");
        const scroller = $(".fixed-col-wrapper-overflow");
        const prev = $(".cabin-prev");
        const next = $(".cabin-next");
        const $this = this;

        
        // enable / disable buttons
        scroller.scroll(function(){
            const maxScrollLen = table.outerWidth() - scroller.outerWidth();
            
            scroller.scrollLeft() === 0 ? 
                prev.addClass("disabled") 
                : prev.removeClass("disabled");
            scroller.scrollLeft() >= maxScrollLen ? 
                next.addClass("disabled") 
                : next.removeClass("disabled");      
        });	

        // ev handlers
        next.click(function(e){
            e.preventDefault();
            var current = scroller.scrollLeft();
            var goTo = $this.distancesArray.find(distance => distance > current +1)
            scroller.animate({
                scrollLeft: goTo
            }, 200)
        })

        prev.click(function(e){
            e.preventDefault();
            var current = scroller.scrollLeft();
            var goTo = $this.distancesArray.slice().reverse().find(distance => distance < current)
            scroller.animate({
                scrollLeft: goTo
            }, 200)
        })   

    },
    createDistancesArray(){
        const table = $("#dateprice-table");
        const scroller = $(".fixed-col-wrapper-overflow");
        const cloned = $("#dateprice-table-cloned");
        const threshold = cloned.offset().left + cloned.outerWidth();
        const thStarts = [];

        scroller.scrollLeft(0);

        table.find("th:nth-child(n+3)").each(function(){
            const l = Math.abs( Math.round( $(this).offset().left ) );
            const l0 = Math.abs( Math.round( l - threshold ) );
            thStarts.push(l0);
        });

        this.distancesArray = thStarts;
    },
    resizeClonedTable(){
        const table = $("#dateprice-table");
        const clone = $("#dateprice-table-cloned");

        const th1 = table.find("th:first-child");
        const th2 = table.find("th:nth-child(2)");

        clone.find("th:first-child").css({
            width: th1.outerWidth(),
            height: th1.outerHeight(),
        });
        clone.find("th:nth-child(2)").css({
            width: th2.outerWidth(),
            height: th2.outerHeight(),
        });

        clone.find("tbody tr").each(function(index, val){
            $(this).css('height', table.find("tbody tr").eq(index).outerHeight() );
        });
    },

    init(){
        const $this = this;
        $(window).load(function(){
            $this.cloneTable();
            $this.createButtons();
            $this.createDistancesArray();
        })
        
        $(window).resize(function(){
            $this.createDistancesArray();
            $this.resizeClonedTable();
        })

    }
}


// ***************************************************
// TOUR/CRUISE PAGE (SHOW RIEPILOGO)
window.showSelectedRiepilogo = function(){
    
    $(document).ready(function(){
		var l_form = $("#large_form");
		var s_form = $("#small_form");
		var btn = $("form").find("button[type='submit']");
		l_form.find("input[type='radio']").change(function(){
			var val = $(this).val();
			var arr = val.split(',');
			s_form.find("input[name='price_description']").val(val);
			btn.find("small").remove();
			btn.append('<small class="small-form-riepilogo">€ ' + arr[1] + ' a persona</small>');
		})
	});
};



window.searchItemsForm = function(){
    var type_sel = window.DryHelpers.getUrlParameter('type');
    var dest_sel = window.DryHelpers.getUrlParameter('dest');
    var typeval = '';



    var filterChildren = function(items, typeval){
        return items.filter(function(){
            return $(this).attr('data-item') == typeval;
        });
    }

    $(document).ready(function(){

        var form = $("#search-items-form");
        if (!form.length) return;

        var type = form.find("#search_type");
        var dest = form.find("#search_dest");
        var options = dest.children();
        dest.children().remove();

        typeval = type.val();
        dest.html( filterChildren(options, typeval) );
        dest.trigger("chosen:updated");


        type.change(function(){
            typeval = $(this).val();
            dest.children().remove();
            dest.html( filterChildren(options, typeval) );
            dest.trigger('chosen:updated');
        });

        
        if (!type_sel.length && !dest_sel.length) {
            dest.val(dest.children().first().val());
        }

        // imposto val perchè attr selected su html non sempre funziona
        if (type_sel.length) {
            $.each(type.children(), function(){
                if ( $(this).val() === type_sel ) {
                    type.val( $(this).val() );
                    type.trigger("change");
                    type.trigger('chosen:updated');
                }
            });
        }

        // imposto val perchè attr selected su html non sempre funziona
        if (dest_sel.length) {
            $.each(dest.children(), function(){
                if ( $(this).val() === dest_sel ) {
                    dest.val( $(this).val() );
                    dest.trigger('chosen:updated');
                }
            });                
        }

        // imposta testo ricerca prima del submit
        form.one('submit', function(e) {
            e.preventDefault();
            var text = type.find("option:selected").text() + "," + dest.find("option:selected").text();
            form.append("<input type='hidden' name='search_text' value='"+text+"' />");
            $(this).submit();
        });

    });
    
};



window.apartmentFilter = function(){
    
    $(document).ready(function(){
        var form = $("#apartment_filter");
        var city = form.find('#select-city');
        var slider = $(".range-slider")[0];
        if (!form.length) return;
    
        var city_sel = window.DryHelpers.getUrlParameter('city_filter');
        var min_budget = window.DryHelpers.getUrlParameter('min_budget');
        var max_budget = window.DryHelpers.getUrlParameter('max_budget');

    
        // imposto val perchè attr selected su html non sempre funziona
        if (city_sel.length) {
            $.each(city.children(), function(){
                if ( $(this).val() === city_sel ) {
                    city.val( $(this).val() );
                    city.trigger("change");
                    city.trigger('chosen:updated');
                }
            });
        }


        if (min_budget.length){
            slider.noUiSlider.set( min_budget );
        }

        if (max_budget.length){
            slider.noUiSlider.set([null, max_budget] );
        }

    })
};


window.escursioneFilter = function(){
    
    $(document).ready(function(){
        var form = $("#escursione_filter");
        var type = form.find('#filter-type');
        var transport = form.find('#filter-transport');
        if (!form.length) return;
    
        var type_sel = window.DryHelpers.getUrlParameter('type');
        var transport_sel = window.DryHelpers.getUrlParameter('transport');

    
        // imposto val perchè attr selected su html non sempre funziona
        if (type_sel.length) {
            $.each(type.children(), function(){
                if ( $(this).val() === type_sel ) {
                    type.val( $(this).val() );
                    type.trigger("change");
                    type.trigger('chosen:updated');
                }
            });
        }


        if (transport_sel.length) {
            $.each(transport.children(), function(){
                if ( $(this).val() === transport_sel ) {
                    transport.val( $(this).val() );
                    transport.trigger("change");
                    transport.trigger('chosen:updated');
                }
            });
        }


       

    })
};